@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.layout {
  min-height: 100vh;
  width: 100%;
  background: var(--background-default);
  background-position: center bottom;
  background-repeat: no-repeat;
}


.logo {
  width: 114px;
  padding: 32px;
  box-sizing: content-box;

  [class*='logoColor'] {
    fill: var(--copilot--default);
  }

  @include respond-to('xs') {
    width: 121px;
  }
}

.wrapperWithBg {
  background: var(--surface-default);
  padding: 40px;
}

.heading {
  margin-bottom: 32px;
  @include typography-v2-title-xl;
}

.sendButtonWrapper {
  margin: 40px 0 16px;
}

.centerContent {
  text-align: center;
}

.cancelButton {
  @include typography-v2-ui-base;

  &:hover {
    text-decoration: underline;
  }
}
